import { combineReducers } from 'redux'
import security from './security'
import context from './context'

export default combineReducers({
  security,
  context,
})
